import request from "@/utils/request";

// 获得医院部门
export function getDepartments() {
  return request({
    url: "/department/api",
    method: "get"
  });
}

// 获得各个小组
export function getGroups() {
  return request({
    url: "/group/api",
    method: "get"
  });
}

// 删除医院部门 和小组
export function deleteHospitalDepartments(data) {
  return request({
    url: "/srs/departments",
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    transformRequest: null,
    data
  });
}

// (新)获得医院部门 和小组
export function getHospitalDepartments() {
  return request({
    url: "/srs/departments",
    method: "get"
  });
}

// 设置医院部门 和小组
export function setHospitalDepartments(data) {
  return request({
    url: "/srs/departments",
    method: "post",
    data
  });
}
